"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
require("./HeaderLinksBar.scss");
var _common = require("../../../core/utils/common");
var HeaderLinksBar = function HeaderLinksBar(props) {
  var isCheckout = (0, _lodash.get)(props, 'isCheckout', false);
  var isEProcurementApp = (0, _lodash.get)(props, 'isEProcurementApp', false);
  var headerLinks = (0, _lodash.get)(props, 'headerContent.headerLinks', {});
  var displayHeaderLinks = headerLinks && !isEProcurementApp && !isCheckout;
  _react.default.useEffect(function () {
    if ((0, _common.isScrollBarVisible)('header-links-nav')) {
      var leftFader = document.querySelector('.fader-container--left');
      leftFader == null ? void 0 : leftFader.classList.add('fader-container--left-visible');
      var headerLinksNav = document.getElementById('header-links-nav');
      if (headerLinksNav) {
        var leftScroll = headerLinksNav.scrollWidth - (headerLinksNav.scrollLeft + headerLinksNav.offsetWidth);
        if (leftScroll !== 0) headerLinksNav.scrollLeft = leftScroll;
      }
    }
  }, [props]);
  var toggleFaders = function toggleFaders(e) {
    var SCROLL_OFFSET = 6;
    var linksNav = e == null ? void 0 : e.target;
    var leftFader = document.querySelector('.fader-container--left');
    var rightFader = document.querySelector('.fader-container--right');
    if ((linksNav == null ? void 0 : linksNav.scrollLeft) > SCROLL_OFFSET) {
      if (!(leftFader != null && leftFader.classList.contains('fader-container--left-visible'))) {
        leftFader == null ? void 0 : leftFader.classList.add('fader-container--left-visible');
      }
    } else {
      leftFader == null ? void 0 : leftFader.classList.remove('fader-container--left-visible');
    }
    if ((linksNav == null ? void 0 : linksNav.scrollWidth) - ((linksNav == null ? void 0 : linksNav.scrollLeft) + (linksNav == null ? void 0 : linksNav.offsetWidth)) < SCROLL_OFFSET) {
      rightFader == null ? void 0 : rightFader.classList.remove('fader-container--right-visible');
    } else if (!(rightFader != null && rightFader.classList.contains('fader-container--right-visible'))) {
      rightFader == null ? void 0 : rightFader.classList.add('fader-container--right-visible');
    }
  };
  return _react.default.createElement(_react.default.Fragment, null, displayHeaderLinks && _react.default.createElement("div", {
    className: "header-links-container"
  }, _react.default.createElement("div", {
    className: "fader-container--left",
    "data-locator": "fader-container--left"
  }), _react.default.createElement("nav", {
    id: "header-links-nav",
    className: "header-links-nav",
    "data-locator": "header-links-nav",
    onScroll: toggleFaders
  }, Object.keys(headerLinks).reverse().map(function (key) {
    var _headerLinks$key = headerLinks[key],
      link = _headerLinks$key.link,
      text = _headerLinks$key.text,
      external = _headerLinks$key.external;
    if (link && text) {
      return _react.default.createElement(_Anchor.default, {
        className: "header-link",
        to: (0, _common.urlSanitize)(link),
        key: text,
        "aria-label": text,
        elementLocator: text,
        target: external ? '_blank' : ''
      }, text);
    }
  })), _react.default.createElement("div", {
    className: "fader-container--right",
    "data-locator": "fader-container--right"
  })));
};
var _default = HeaderLinksBar;
exports.default = _default;
module.exports = exports["default"];